export const nearbyProjectsLayerIds: string[] = [
  // 'projects',
  'pavingProjects',
  'pavingMoratorium',
  'cipProjects',
];

export const rightOfWayLayerIds: string[] = ['landUseRailroads', 'transitRoutes', 'landUseRightOfWay'];

export const jurisdictionalIntersectionLayerIds: string[] = [
  'landUseTransportationDistrictBoundaries',
  'county',
  'incorporatedPlaces',
];

export const floodHazardLayerIds: string[] = [
  'geotechnicalBaseFloodElevations',
  'geotechnicalCoastalTransects',
  'geotechnicalCrossSections',
  'geotechnicalFloodHazardZones',
];

export const floodControlLayerIds: string[] = [
  'geotechnicalLeveeSystemPoints',
  'geotechnicalLeveeSystemLines',
  'geotechnicalLeveeAreas',
  'otherJurisdictionalDams',
];

export const waterbodiesLayerIds: string[] = [
  'streams',
  'waterbodies',
  'environmentalWetlands',
  'environmentalDesignatedFloodway',
  'environmental303dImpairedWaters',
  'environmentalRegulatedStreams',
];

export const hydrologyLayerIds: string[] = [...floodHazardLayerIds, ...floodControlLayerIds, ...waterbodiesLayerIds];

export const bridgesLayerIds: string[] = ['landUseStateHighwayBridges'];

export const civicLayerIds: string[] = [
  'otherCSCDUniversityLands',
  'otherCollegesUniversities',
  'otherHospitals',
  'otherK12Schools',
  'otherCSCDSchools',
];

export const energyLayerIds: string[] = [
  'geotechnicalOilGasWells',
  'geotechnicalOilGasRefineriesProcessingPlants',
  'geotechnicalPowerPlants',
];

export const physicalInfrastructureLayerIds: string[] = [
  ...hydrologyLayerIds,
  ...bridgesLayerIds,
  ...energyLayerIds,
  ...civicLayerIds,
];

export const intelligenceLayers: string[] = [
  ...nearbyProjectsLayerIds,
  ...rightOfWayLayerIds,
  ...jurisdictionalIntersectionLayerIds,
  ...physicalInfrastructureLayerIds,
] as const;

export const layersToSkipRender: string[] = [
  'transitRoutes',
  'landUseRightOfWay',
  'landUseTransportationDistrictBoundaries',
] as const;
